import React from 'react';
import { makeStyles } from '@mui/styles';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';

import map from '../../assets/mapVillare.png';

const useStyles = makeStyles((theme) => ({
  text: {
    textAlign: 'justify',
    width: '50%',
  },
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    marginLeft: '3em',
  },
  containerContact: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  icon: {
    margin: '0.5em',
    color: 'darkgrey',
  },
  containerGlobalContact: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
  },
  image: {
    width: '30%',
    marginBottom: '1em',
  },
  [theme.breakpoints.down(760)]: {
    image: {
      width: '85%',
    },
    container: {
      marginLeft: '0em',
    },
  },
}));

const Header = () => {
  const classes = useStyles();
  return (
    <div className={classes.containerGlobalContact}>
      <img className={classes.image} src={map} alt="mapVillaré" />
      <div className={classes.container}>
        <div className={classes.containerContact}>
          <LocalPhoneIcon className={classes.icon} />
          <a href="tel:0659193437">0659193437</a>
        </div>
        <div className={classes.containerContact}>
          <EmailIcon className={classes.icon} />
          <a href="mailto:rit.zen.thaler@hotmail.fr">Envoyer un email</a>
        </div>
        <div className={classes.containerContact}>
          <HomeIcon className={classes.icon} />
          <p>Situé dans le nord de la Seine-et-Marne</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
